import HttpRequest from './http_request'

class PromotionProvider extends HttpRequest {
  constructor () {
    super(`${process.env.NEW_API}/public/5e3548c2d32cb12606a34fb8`)
  }

  async verifyPromotionCode (payload) {
    const validatePromotionCodePayload = {
      code: payload.code,
      member: {
        tel: payload.memberTel
      },
      items: payload.items.map(item => {
        return {
          sku_id: parseInt(item.id),
          code: item.code,
          name: item.name,
          amount: parseInt(item.amount),
          option: '',
          price: parseFloat(item.priceDiscount),
          full_price: parseFloat(item.price),
          productId: parseInt(item.productId),
          brand: {
            id: 1,
            name: 'gentlewoman'
          },
          warehouse: {
            id: payload.warehouse.id,
            name: payload.warehouse.name,
            code: payload.warehouse.code
          },
          categories: item.categories,
          tags: item.tags
        }
      }),
      channel: 'pos'
    }
    try {
      const { data } = await this.create('/promotion-codes/validate', validatePromotionCodePayload)
      return data
    } catch (error) {
      return {
        data: { success: false,
          error: {
            message: error.response ? error.response.data.message : ''
          }
        }
      }
    }
  }
}

export default PromotionProvider



// WEBPACK FOOTER //
// ./src/resources/promotion_provider.js